// this is superflous with /support (when ENABLE_PYPESTREAM flag is off) but adding just in case its used somehow
export { default } from 'features/support/flows/case-form/support-v2-categories-page';
